import { css } from "@emotion/react";

import { COLORS } from "styles-js";

const cookiePolicyLink = css`
    color: ${COLORS.primary};
    cursor: pointer;
`;

interface CookieDetailProps {
  cookie: {
    name: string;
    provider: string;
    expiration: string;
    purpose: string;
    source: string;
    processor: string;
  };
  toggleShowCookiePolicy: () => void;
}

function CookieDetail({ cookie, toggleShowCookiePolicy }: CookieDetailProps) {

  return (
    <>
      <div>
        <strong>Nombre de la cookie: </strong>
        <span>{cookie.name}</span>
      </div>
      <div>
        <strong>Proveedor: </strong>
        <span>{cookie.provider}</span>
      </div>
      <div>
        <strong>Caducidad: </strong>
        <span>{cookie.expiration}</span>
      </div>
      <div>
        <strong>El objetivo de la cookie: </strong>
        <span>{cookie.purpose}</span>
      </div>
      <div>
        <strong>Fuente: </strong>
        {
          cookie.source === "https://mykredit.es/" ?
            <span css={cookiePolicyLink} onClick={toggleShowCookiePolicy}>{cookie.source}</span> :
            <a target="_blank" href={cookie.source}>{cookie.source}</a>
        }
      </div>
      <div>
        <strong>Processor: </strong>
        <span>{cookie.processor}</span>
      </div>
      <hr />
    </>
  );
}

export default CookieDetail;
